var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoney(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "-9.98 0 48.891 48.891",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "reciept_money",
    "data-name": "reciept money",
    transform: "translate(-236.032 -321.837)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M264.468,322.337H236.532v47.891h27.937V322.337Z",
    fill: "#f2f7fd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M264.468,366.237H236.532v3.991h27.937v-3.991Z",
    fill: "#354077",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M254.491,322.337h-7.982v0a3.988,3.988,0,0,0,3.987,3.987h0a3.99,3.99,0,0,0,3.991-3.991Z",
    fill: "#354077",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M250.5,338.3a7.982,7.982,0,1,1-7.982,7.981A7.984,7.984,0,0,1,250.5,338.3Z",
    fill: "#ffe959",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M242.518,358.255h15.964M242.518,334.31h15.964m-3.991-11.973h-7.982v0a3.988,3.988,0,0,0,3.987,3.987h0a3.99,3.99,0,0,0,3.991-3.991Zm9.977,43.9h0Zm-9.977,3.991h9.977V322.337H236.532v47.891h9.977m3.492,0h1m-.5-31.927a7.982,7.982,0,1,1-7.982,7.981A7.984,7.984,0,0,1,250.5,338.3Zm0,11.972v1m0-9.977v1m-2,5.986a2,2,0,1,0,2-2m1.995-2a2,2,0,1,0-1.995,2",
    fill: "none",
    stroke: "#0f0e0b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.1ca95f563db5314a1299a3d30ecf6b66.svg";
export { ForwardRef as ReactComponent };